//@flow
import Model from '../../Utils/Model/model';

export type ProcessorType = 'cryozonic_stripe'|'amazon'|'authnetcim';

export type CreditCardObject = {
  id:string,
  card_brand:string,
  last4:string,
  expiration_month:number,
  expiration_year:number,
  address_id:?string,
  processor_type:ProcessorType,
  billing_agreement_id?:string,
};

export default class CreditCardModel extends Model<CreditCardObject> {

  getId():string {
    return (this.attributes.id || '') + '';
  }

  getType():string {
    return this.attributes.card_brand || '';
  }

  getAmazonId():?string {
    return this.attributes.billing_agreement_id;
  }

  getLast4():string {
    return this.attributes.last4 || '';
  }

  getExpMonth():number|'' {
    return this.attributes.expiration_month || '';
  }

  getExpYear():number|'' {
    return this.attributes.expiration_year || '';
  }

  getProcessorType():ProcessorType {
    return this.attributes.processor_type;
  }

  isExpired():boolean {
    const expMonth = this.getExpMonth();
    const expYear = this.getExpYear();
    if (!expMonth || !expYear) {
      return false;
    }

    const today = new Date();
    const mm = today.getMonth()+1;
    const yyyy = today.getFullYear();

    if (yyyy < expYear) {
      return false;
    }
    if ((yyyy == expYear) && (mm <= expMonth)) {
      return false;
    }

    return true;
  }

  getAddressId():?string {
    return this.attributes.address_id;
  }
}
